export const GET_CHATS = 'chats/GET_CHATS'
export const GET_CHATS_SUCCESSFUL = 'chats/GET_CHATS_SUCCESSFUL'
export const GET_CHATS_FAILURE = 'chats/GET_CHATS_FAILURE'

export const CLEAR_PRIVATE_ROOMS = 'chats/CLEAR_PRIVATE_ROOMS'
export const GET_PRIVATE_ROOMS_SUCCESSFUL = 'chats/GET_PRIVATE_ROOMS_SUCCESSFUL'
export const SET_PRIVATE_ROOMS_ORDER = 'chats/SET_PRIVATE_ROOMS_ORDER'

export const CLEAR_GROUP_ROOMS = 'chats/CLEAR_GROUP_ROOMS'
export const GET_GROUP_ROOMS_SUCCESSFUL = 'chats/GET_GROUP_ROOMS_SUCCESSFUL'
export const SET_GROUP_ROOMS_ORDER = 'chats/SET_GROUP_ROOMS_ORDER'

export const CLEAR_MEDIATION_ROOMS = 'chats/CLEAR_MEDIATION_ROOMS'
export const GET_MEDIATION_ROOMS_SUCCESSFUL =
  'chats/GET_MEDIATION_ROOMS_SUCCESSFUL'
export const SET_MEDIATION_ROOMS_ORDER = 'chats/SET_MEDIATION_ROOMS_ORDER'

export const CLEAR_ARCHIVED_ROOMS = 'chats/CLEAR_ARCHIVED_ROOMS'
export const GET_ARCHIVED_ROOMS_SUCCESSFUL =
  'chats/GET_ARCHIVED_ROOMS_SUCCESSFUL'

export const CREATE_CHAT_SUCCESSFUL = 'chats/CREATE_CHAT_SUCCESSFUL'
export const CREATE_CHAT_FAILURE = 'chats/CREATE_CHAT_FAILURE'

export const GET_CHAT_BY_ID = 'chats/GET_CHAT_BY_ID'
export const GET_CHAT_BY_ID_SUCCESSFUL = 'chats/GET_CHAT_BY_ID_SUCCESSFUL'
export const GET_CHAT_BY_ID_FAILURE = 'chats/GET_CHAT_BY_ID_FAILURE'

export const DELETE_CHAT = 'chats/DELETE_CHAT'
export const DELETE_CHAT_SUCCESSFUL = 'chats/DELETE_CHAT_SUCCESSFUL'
export const DELETE_CHAT_FAILURE = 'chats/DELETE_CHAT_FAILURE'

export const UPDATE_GROUP_ROOM_REDUCER = 'chats/UPDATE_GROUP_ROOM_REDUCER'
export const UPDATE_ROOM_UNREAD_COUNT = 'chats/UPDATE_ROOM_UNREAD_COUNT'
export const FILTER_ARCHIVED = 'chats/FILTER_ARCHIVED'

export const CREATE_CHAT_RSPA = 'rspa: chats/CREATE_CHAT'
export const CREATE_MESSAGE_RSPA = 'rspa: chats/CREATE_MESSAGE'
export const GET_MESSAGES_RSPA = 'rspa: chats/GET_MESSAGES'
export const GET_INTERVENTION_MESSAGE_RSPA =
  'rspa: chats/GET_INTERVENTION_MESSAGE'
export const GET_MESSAGES_WITHOUT_ROOM_RSPA =
  'rspa: chats/GET_MESSAGES_WITHOUT_ROOM'
export const GET_ROOMS_RSPA = 'rspa: chats/GET_ROOMS'
export const GET_ROOM_BY_ID_RSPA = 'rspa: chats/GET_ROOM_BY_ID'
export const EDIT_MESSAGE_RSPA = 'rspa: chats/EDIT_MESSAGE'
export const DELETE_MESSAGE_RSPA = 'rspa: chats/DELETE_MESSAGE'
export const EXPORT_MESSAGES_RSPA = 'rspa: chats/EXPORT_MESSAGES'
export const EDIT_ROOM_RSPA = 'rspa: chats/EDIT_ROOM'
